export const PaymentCategories = Object.freeze({
  RENTAL: 'rental',
  WATER: 'utilities_water',
  ELECTRICITY: 'utilities_electricity',
  MISC: 'misc',
  VIOLATION: 'violation',
  RESERVATION: 'reservation',
  OVERPAYMENT: 'overpayment',
  SECURITY_DEPOSIT: 'security_deposit',
  DOWN_PAYMENT: 'down_payment'
})

export const PaymentStatus = Object.freeze({
  PENDING: 'pending',
  PAID: 'paid',
  PAID_LATE: 'paid_late',
  CANCELED: 'canceled',
  VOID: 'void',
  VOID_CREDIT_BALANCE: 'void_credit_balance',
  WAIVED: 'waived',
  POSTDATED: 'postdated',
  PAID_PARTIAL: 'paid_partial',
  PENDING_APPROVAL: 'pending_approval',
  PENDING_PAYMENT_APPROVAL: 'pending_payment_approval'
})

export const paymentStatusSelect = [
  { text: 'Pending', value: PaymentStatus.PENDING },
  { text: 'Paid', value: `${PaymentStatus.PAID}|${PaymentStatus.PAID_LATE}` },
  { text: 'Partial payment', value: PaymentStatus.PAID_PARTIAL },
  { text: 'Post dated', value: PaymentStatus.POSTDATED },
  { text: 'On time payments', value: PaymentStatus.PAID },
  { text: 'Late payments', value: PaymentStatus.PAID_LATE },
  { text: 'Pending approval (request)', value: PaymentStatus.PENDING_APPROVAL },
  {
    text: 'Pending approval (paid)',
    value: PaymentStatus.PENDING_PAYMENT_APPROVAL
  },
  {
    text: 'Void',
    value: `${PaymentStatus.VOID}|${PaymentStatus.VOID_CREDIT_BALANCE}`
  },
  { text: 'Canceled', value: `${PaymentStatus.CANCELED}` }
]

const categoryText = {
  [PaymentCategories.ELECTRICITY]: 'Electricity',
  [PaymentCategories.WATER]: 'Water',
  [PaymentCategories.MISC]: 'Misc',
  [PaymentCategories.RENTAL]: 'Rent',
  [PaymentCategories.VIOLATION]: 'Violation',
  [PaymentCategories.RESERVATION]: 'Reservation',
  [PaymentCategories.OVERPAYMENT]: 'Overpayment',
  [PaymentCategories.SECURITY_DEPOSIT]: 'Security Deposit',
  [PaymentCategories.DOWN_PAYMENT]: 'Down Payment'
}

const statusText = {
  [PaymentStatus.PENDING]: 'Pending',
  [PaymentStatus.PAID]: 'Paid',
  [PaymentStatus.PAID_LATE]: 'Paid/Late',
  [PaymentStatus.VOID]: 'Void',
  [PaymentStatus.VOID_CREDIT_BALANCE]: 'Void/Credited',
  [PaymentStatus.WAIVED]: 'Waived',
  [PaymentStatus.POSTDATED]: 'Postdated',
  [PaymentStatus.CANCELED]: 'Canceled',
  [PaymentStatus.PAID_PARTIAL]: 'Partial payment',
  [PaymentStatus.PENDING_APPROVAL]: 'Pending approval (request)',
  [PaymentStatus.PENDING_PAYMENT_APPROVAL]: 'Pending approval (paid)'
}

export function parsePaymentStatus(raw) {
  return statusText[raw] || raw
}

export function parsePaymentCategory(raw) {
  return categoryText[raw] || raw
}

export const PaidPaymentStatus = Object.freeze({
  PAID: 'paid',
  CANCELED: 'canceled',
  VOID: 'void',
  PENDING_APPROVAL: 'pending_approval'
})

const paidPaymentStatusText = {
  [PaidPaymentStatus.PAID]: 'Paid',
  [PaidPaymentStatus.CANCELED]: 'Canceled',
  [PaidPaymentStatus.VOID]: 'Void',
  [PaidPaymentStatus.PENDING_APPROVAL]: 'Pending approval (paid)'
}

export function parsePaidPaymentStatus(raw) {
  return paidPaymentStatusText[raw] || raw
}

export const PaymentTypes = Object.freeze({
  POST_DATED_CHECK: 'post_dated_check',
  ONE_TIME_PAYMENT: 'one_time_payment'
})

export const PaymentTypesText = {
  [PaymentTypes.POST_DATED_CHECK]: 'Post dated check',
  [PaymentTypes.ONE_TIME_PAYMENT]: 'One time payment'
}

export const PaymentTypesSelect = Object.values(PaymentTypes).map((value) => ({
  text: PaymentTypesText[value],
  value: value
}))

export const paidPaymentStatusSelect = Object.values(PaidPaymentStatus).map(
  (value) => ({
    text: paidPaymentStatusText[value],
    value
  })
)

export const forbiddenCreatePaymentRequestCategories = [
  PaymentCategories.RENTAL,
  PaymentCategories.SECURITY_DEPOSIT,
  PaymentCategories.OVERPAYMENT,
  PaymentCategories.DOWN_PAYMENT
]
